var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLojinhaHomeCart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2439,
    cy: 31.5541,
    rx: 32.2683,
    ry: 31.5541
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.439 39.0361C27.1244 39.0361 26.0607 40.0879 26.0607 41.3734C26.0607 42.659 27.1244 43.7108 28.439 43.7108C29.7537 43.7108 30.8293 42.659 30.8293 41.3734C30.8293 40.0879 29.7537 39.0361 28.439 39.0361ZM21.2683 20.3373V22.6747H23.6585L27.961 31.5449L26.3476 34.4081C26.1563 34.7354 26.0488 35.121 26.0488 35.5301C26.0488 36.8156 27.1244 37.8674 28.439 37.8674H42.7805V35.5301H28.941C28.7737 35.5301 28.6422 35.4015 28.6422 35.2379L28.678 35.0977L29.7537 33.1927H38.6573C39.5537 33.1927 40.3424 32.7136 40.7488 31.989L45.0273 24.4043C45.1229 24.2407 45.1707 24.042 45.1707 23.8434C45.1707 23.2006 44.6329 22.6747 43.9756 22.6747H26.2998L25.1763 20.3373H21.2683ZM40.3902 39.0361C39.0756 39.0361 38.0119 40.0879 38.0119 41.3734C38.0119 42.659 39.0756 43.7108 40.3902 43.7108C41.7049 43.7108 42.7805 42.659 42.7805 41.3734C42.7805 40.0879 41.7049 39.0361 40.3902 39.0361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6829,
    height: 28.0481,
    fill: "white",
    transform: "translate(17 18)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLojinhaHomeCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lojinha-home-cart.f7823c6e.svg";
export { ForwardRef as ReactComponent };